import {
  PortalAuthCtaSection,
  PortalAuthGate,
} from "@xinosolutions/xs-auth-react/portal";
import { Link as RouterLink } from "react-router-dom";
import SignInLink from "./SignInLink";
import CreateAccountLink from "./CreateAccountLink";
import SiteFooter from "./SiteFooter";

const portalSignInComponents = {
  SignInPrimary: CreateAccountLink,
  SignInSecondary: SignInLink,
};

function renderDashboardLink({ href, className, children }) {
  return (
    <RouterLink to={href} className={className}>
      {children}
    </RouterLink>
  );
}

export default function LandingContent() {
  return (
    <>
      <section className="portal-hero">
        <div className="portal-hero-badge">Xino Solutions</div>
        <h1>
          Admin console
          <br />
          <span className="portal-hero-gradient">ready to customize</span>
        </h1>
        <p>
          Sign in with XS Auth to manage your product. Clone this admin app and
          build your operations tools on top.
        </p>
        <PortalAuthGate
          dashboardHref="/dashboard"
          dashboardLabel="Open dashboard"
          primaryLabel="Create account"
          secondaryLabel="Sign in"
          secondaryClassName="portal-btn portal-btn--ghost"
          renderDashboardLink={renderDashboardLink}
          {...portalSignInComponents}
        />
      </section>

      <PortalAuthCtaSection
        title="Ready to manage your product?"
        authenticatedText="Continue to your admin dashboard."
        unauthenticatedText="Create a free account and open the admin dashboard in seconds."
        dashboardHref="/dashboard"
        dashboardLabel="Open dashboard"
        primaryLabel="Get started"
        showSecondarySignIn={false}
        SignInPrimary={CreateAccountLink}
        renderDashboardLink={renderDashboardLink}
      />

      <SiteFooter />
    </>
  );
}
